import React from "react";
import { Star } from "lucide-react";

const GoogleG = ({ className = "w-5 h-5" }) => (
  <svg className={className} viewBox="0 0 48 48">
    <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"/>
    <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"/>
    <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"/>
    <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"/>
  </svg>
);

const REVIEWS = [
  { name: "Rajesh Mehta", avatar: "R", color: "#EA4335", rating: 5, date: "1 week ago", text: "Ark Design transformed our home into something beyond imagination. Professional team, stunning execution." },
  { name: "Priya Kapoor", avatar: "P", color: "#4285F4", rating: 5, date: "2 weeks ago", text: "Their interior design work is world-class. Every detail was thoughtfully considered. Highly recommend!" },
  { name: "Sunil Arora", avatar: "S", color: "#34A853", rating: 5, date: "1 month ago", text: "Outstanding architecture firm. Our commercial project was delivered on time and exceeded expectations." },
  { name: "Anita Singh", avatar: "A", color: "#FBBC05", rating: 5, date: "3 weeks ago", text: "The 3D visualization helped us understand the design before construction. Brilliant team!" },
  { name: "Vikram Sharma", avatar: "V", color: "#EA4335", rating: 5, date: "2 months ago", text: "Landscape design work is breathtaking. Our garden is now the talk of the neighbourhood." },
  { name: "Neha Gupta", avatar: "N", color: "#4285F4", rating: 5, date: "5 days ago", text: "Renovated our old apartment beautifully. Attention to detail and quality of work is excellent." },
];

const LOOP = [...REVIEWS, ...REVIEWS];

export default function GoogleReviews() {
  return (
    <section className="py-16 md:py-20" style={{ background: "var(--color-bg-soft)" }}>
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-10">
          <div className="flex items-center gap-4">
            <div className="h-12 w-12 rounded-xl bg-white border border-gray-200 shadow-sm flex items-center justify-center">
              <GoogleG className="w-6 h-6" />
            </div>
            <div>
              <div className="flex items-center gap-2">
                <span className="font-semibold text-gray-900 text-lg" style={{ fontFamily: "var(--font-heading)" }}>
                  Google Reviews
                </span>
              </div>
              <div className="flex items-center gap-2 mt-0.5">
                <div className="flex gap-0.5">
                  {[1,2,3,4,5].map(i => (
                    <Star key={i} className="w-4 h-4 fill-current" style={{ color: "#FBBC05" }} />
                  ))}
                </div>
                <span className="text-sm font-semibold text-gray-900">5.0</span>
                <span className="text-xs text-gray-500">· Based on Google Reviews</span>
              </div>
            </div>
          </div>
          <a
            href="https://www.google.com/search?q=Ark+Design+International+Noida"
            target="_blank"
            rel="noopener noreferrer"
            className="text-xs font-semibold text-gray-700 hover:text-black tracking-widest uppercase"
          >
            See all reviews →
          </a>
        </div>

        <div className="relative overflow-hidden">
          <div className="pointer-events-none absolute inset-y-0 left-0 w-16 bg-gradient-to-r from-stone-50 to-transparent z-10" />
          <div className="pointer-events-none absolute inset-y-0 right-0 w-16 bg-gradient-to-l from-stone-50 to-transparent z-10" />
          <div className="reviews-track flex gap-5 w-max">
            {LOOP.map((r, i) => (
              <article
                key={i}
                className="w-[300px] md:w-[340px] flex-shrink-0 bg-white border border-gray-200 rounded-xl p-5 hover:shadow-md transition-shadow"
              >
                <header className="flex items-center gap-3">
                  <div className="h-10 w-10 rounded-full flex items-center justify-center text-white font-bold text-sm" style={{ backgroundColor: r.color }}>
                    {r.avatar}
                  </div>
                  <div className="min-w-0">
                    <div className="font-semibold text-gray-900 text-sm truncate">{r.name}</div>
                    <div className="text-[11px] text-gray-500">{r.date}</div>
                  </div>
                  <GoogleG className="w-4 h-4 ml-auto flex-shrink-0" />
                </header>
                <div className="mt-3 flex gap-0.5">
                  {Array.from({ length: 5 }).map((_, k) => (
                    <Star key={k} className="w-4 h-4 fill-current" style={{ color: "#FBBC05" }} />
                  ))}
                </div>
                <p className="mt-3 text-sm text-gray-600 leading-relaxed line-clamp-4">"{r.text}"</p>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
